'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationLegendController = function OnlineLogitCalibrationLegendController($scope) {
  var availableViewOptions = [{
    name: 'fixed',
    selected: true
  }, {
    name: 'scheduled',
    selected: false
  }];
  $scope.scenarios = _.isNil($scope.selectedView) ? availableViewOptions : initSelectedViews();
  function initSelectedViews() {
    var selectedViews = _.cloneDeep(availableViewOptions);
    _.forEach(selectedViews, function (view) {
      var viewObj = _.find($scope.selectedView, {
        name: view.name
      });
      view.selected = _.isNil(viewObj) ? false : viewObj.selected;
    });
    return selectedViews;
  }
  $scope.selectedScenario = _.filter($scope.scenarios, {
    selected: true
  });
  $scope.scenarioChange = function () {
    $scope.selectedScenario = _.filter($scope.scenarios, {
      selected: true
    });
    $scope.$emit('online-logit-calibration:scenario-toggle', $scope.selectedScenario);
  };
};
OnlineLogitCalibrationLegendController.$inject = ['$scope'];
module.exports = OnlineLogitCalibrationLegendController;